var $ = require("jquery");

module.exports = {
	init: function () {
		console.log(
			"Menu module initialized",
			$("#mobile-menu-toggle"),
			$("#mobile-menu"),
			$("#mobile-menu-close"),
			$(".nav-toggle"),
		);
		// Legacy nav toggle
		$(".nav-toggle").on("click", function () {
			$(".header").toggleClass("--active");
			$(".header-nav").toggleClass("--active");
		});

		// New mobile menu toggle
		$("#mobile-menu-toggle").on("click", function () {
			$("#mobile-menu").toggleClass("--hidden");
		});

		$("#mobile-menu-close").on("click", function () {
			$("#mobile-menu").addClass("--hidden");
		});

		// Close mobile menu when clicking backdrop
		$("#mobile-menu .fixed.inset-0").on("click", function () {
			$("#mobile-menu").addClass("--hidden");
		});
	},
};
